import { toast } from '@core/component/Toast/Toast';
import type { EntityData } from '@entity';
import { createBulkCopyDssEntityMutation } from '@macro-entity';
import type { SoupState } from '../create-soup-state';

export const makeCopyAction = () => {
  const bulkCopyMutation = createBulkCopyDssEntityMutation();

  const canExecute = (entity: EntityData): boolean => {
    return (
      entity.type !== 'channel' &&
      entity.type !== 'email' &&
      entity.type !== 'channel_message' &&
      entity.type !== 'foreign'
    );
  };

  const execute = async (entities: EntityData[]) => {
    await bulkCopyMutation.mutateAsync({
      entities,
      name: (name) => name,
    });
    toast.success(
      entities.length > 1 ? `Copied ${entities.length} items` : 'Copied'
    );
  };

  const executeWithSoup = async (entities: EntityData[], soup: SoupState) => {
    await execute(entities);
    soup.selection.clear();
  };

  return { canExecute, execute, executeWithSoup };
};
